import React, { useState, useEffect, useRef } from "react";
import { profileAvatar } from "../component/ImageList";
import baseURL from "../component/baseURL";
import stringsoflanguages from '../component/stringsoflanguages';
import { useLocation, useNavigate } from 'react-router-dom';
import showNotification from '../component/Notification';

const PREMIUM_MEMBERS_GRID_SCROLL_KEY = 'yesmls_premiumMembers_gridScrollTop';
const PREMIUM_MEMBERS_RESTORE_SCROLL_PENDING_KEY = 'yesmls_premiumMembers_restoreScrollPending';

export default function PremiumMembers() {

    const navigate = useNavigate();
    const location = useLocation();
    const [premiumMembers, setPremiumMembers] = useState([]);
    const [checkFilterStatus, setCheckFilterStatus] = useState(false);
    const [allConnections, setAllConnections] = useState([]);
    const [filteredConnections, setFilteredConnections] = useState([]);
    const [loadData, setLoadData] = useState(false);
    const [loading, setLoading] = useState(true);
    const [searchText, setSearchText] = useState("");
    const [gearMenuOpen, setGearMenuOpen] = useState(false);
    const [gearSpinning, setGearSpinning] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const gearMenuRef = useRef(null);
    /** `.member-cards-grid` has overflow-y: auto — scroll is here, not on window */
    const listScrollRef = useRef(null);

    useEffect(() => {
        const userid = localStorage.getItem('user_id');
        fetchDetailsAPI(userid);
    }, []);

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth <= 767);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (gearMenuRef.current && !gearMenuRef.current.contains(e.target)) {
                setGearMenuOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    /** Persist grid scroll while browsing */
    useEffect(() => {
        if (!loadData) return undefined;
        const el = listScrollRef.current;
        if (!el) return undefined;
        let timeoutId;
        const onScroll = () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                sessionStorage.setItem(PREMIUM_MEMBERS_GRID_SCROLL_KEY, String(el.scrollTop));
            }, 120);
        };
        el.addEventListener('scroll', onScroll, { passive: true });
        return () => {
            clearTimeout(timeoutId);
            el.removeEventListener('scroll', onScroll);
        };
    }, [loadData]);

    /** Restore grid scroll after returning from member profile */
    useEffect(() => {
        if (!loadData) return undefined;
        if (sessionStorage.getItem(PREMIUM_MEMBERS_RESTORE_SCROLL_PENDING_KEY) !== '1') {
            return undefined;
        }
        const raw = sessionStorage.getItem(PREMIUM_MEMBERS_GRID_SCROLL_KEY);
        if (raw == null || raw === '') {
            sessionStorage.removeItem(PREMIUM_MEMBERS_RESTORE_SCROLL_PENDING_KEY);
            return undefined;
        }
        const y = Number(raw);
        if (!Number.isFinite(y) || y < 0) {
            sessionStorage.removeItem(PREMIUM_MEMBERS_RESTORE_SCROLL_PENDING_KEY);
            return undefined;
        }

        const apply = () => {
            const el = listScrollRef.current;
            if (el) el.scrollTop = y;
        };
        const clearPending = () => {
            sessionStorage.removeItem(PREMIUM_MEMBERS_RESTORE_SCROLL_PENDING_KEY);
        };

        apply();
        const t0 = window.setTimeout(() => {
            apply();
            clearPending();
        }, 0);
        const t1 = window.setTimeout(apply, 80);
        const t2 = window.setTimeout(() => {
            apply();
            clearPending();
        }, 300);

        return () => {
            clearTimeout(t0);
            clearTimeout(t1);
            clearTimeout(t2);
        };
    }, [loadData, filteredConnections?.length ?? 0]);

    function fetchDetailsAPI(userid) {
        console.log(userid)
        if (!userid) {
            console.log('*********No User***********')
        }
        let formdata = new FormData();
        formdata.append("user_id", userid)
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055")
        formdata.append("member_type", 'pool')
        formdata.append("subscription", '1')
        fetch(baseURL.URL + '/member/fetch_members', {
            method: 'POST',
            body: formdata

        }).then((response) => response.json())
            .then((responseJson) => {
                const memberList = responseJson?.response?.member_list;
                const result = Array.isArray(memberList) ? memberList : [];
                console.log(responseJson)
                if (responseJson.server.result_code === 200) {
                    setCheckFilterStatus(responseJson.response?.filter_on ?? false)
                    setAllConnections(result)
                    setFilteredConnections(result)
                }
                else {
                    showNotification('Error', responseJson.server.message, 'danger');
                    setAllConnections([])
                    setFilteredConnections([])
                }
            })
            .catch((error) => {
                console.error(error);
                setAllConnections([])
                setFilteredConnections([])
            })
            .finally(() => {
                setLoadData(true);
                setLoading(false);
            });
    }

    function normalizeDisplayValue(value) {
        if (value == null) return "";
        const normalized = String(value).trim();
        if (!normalized) return "";
        const lowered = normalized.toLowerCase();
        if (lowered === "null" || lowered === "undefined") return "";
        return normalized;
    }

    function handleSearchByName(event) {
        const value = event.target.value;
        setSearchText(value);
        const normalizedSearch = value.trim().toLowerCase();

        const connections = Array.isArray(allConnections) ? allConnections : [];

        if (!normalizedSearch) {
            setFilteredConnections(connections);
            return;
        }

        const filtered = connections.filter((member) => {
            const firstName = normalizeDisplayValue(member?.member_fname).toLowerCase();
            const lastName = normalizeDisplayValue(member?.member_lname).toLowerCase();
            const fullName = `${firstName} ${lastName}`.trim();
            return fullName.includes(normalizedSearch);
        });

        setFilteredConnections(filtered);
    }


    const handleMemberCardClick = (member) => {
        const el = listScrollRef.current;
        const gridScroll = el ? el.scrollTop : 0;
        sessionStorage.setItem(PREMIUM_MEMBERS_GRID_SCROLL_KEY, String(gridScroll));
        sessionStorage.setItem(PREMIUM_MEMBERS_RESTORE_SCROLL_PENDING_KEY, '1');
        sessionStorage.setItem('premiumMembersScrollPosition', String(gridScroll));
        navigate('/member-profile', {
            state: {
                memberID: member.user_id,
                member,
                scrollPosition: gridScroll,
                from: location.pathname,
            },
        });
    };

    if (loading) {
        return (
            <div className={`content-right ${isMobile ? 'feed-recived-page-mobile' : ''} page-loader-wrapper`}>
                <div className="react-js-loader">
                    <div className="react-js-loader-spinner"></div>
                    <p className="react-js-loader-text">{stringsoflanguages.loading}</p>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className={`content-right ${isMobile ? 'feed-recived-page-mobile' : ''}`}>
                {/* Search and Filter Section */}
                <div className="search-filter-section">
                    <div className="search-bar">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            className="search-icon"
                        >
                            <path
                                d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
                                stroke="#E1730B"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M17.5 17.5L13.875 13.875"
                                stroke="#E1730B"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                        <input
                            type="text"
                            placeholder="Search by name / company"
                            className="search-input"
                            value={searchText}
                            onChange={handleSearchByName}
                        />
                    </div>
                    <button className="filter-btn">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="none"
                        >
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M16.4062 4.69678C14.5256 4.69678 12.9441 6.04475 12.5793 7.82178H2.34375C1.91228 7.82178 1.5625 8.17156 1.5625 8.60303C1.5625 9.0345 1.91228 9.38428 2.34375 9.38428H12.5793C12.9441 11.1613 14.5256 12.5093 16.4062 12.5093C18.2869 12.5093 19.8684 11.1613 20.2332 9.38428H22.6562C23.0877 9.38428 23.4375 9.0345 23.4375 8.60303C23.4375 8.17156 23.0877 7.82178 22.6562 7.82178H20.2332C19.8684 6.04475 18.2869 4.69678 16.4062 4.69678ZM16.4062 6.25928C17.7099 6.25928 18.75 7.29938 18.75 8.60303C18.75 9.90668 17.7099 10.9468 16.4062 10.9468C15.1026 10.9468 14.0625 9.90668 14.0625 8.60303C14.0625 7.29938 15.1026 6.25928 16.4062 6.25928Z"
                                fill="white"
                            />
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M8.59375 12.5093C6.71313 12.5093 5.1316 13.8573 4.76685 15.6343H2.34375C1.91228 15.6343 1.5625 15.9841 1.5625 16.4155C1.5625 16.847 1.91228 17.1968 2.34375 17.1968H4.76685C5.1316 18.9738 6.71313 20.3218 8.59375 20.3218C10.4744 20.3218 12.0559 18.9738 12.4207 17.1968H22.6562C23.0877 17.1968 23.4375 16.847 23.4375 16.4155C23.4375 15.9841 23.0877 15.6343 22.6562 15.6343H12.4207C12.0559 13.8573 10.4744 12.5093 8.59375 12.5093ZM8.59375 14.0718C9.8974 14.0718 10.9375 15.1119 10.9375 16.4155C10.9375 17.7192 9.8974 18.7593 8.59375 18.7593C7.2901 18.7593 6.25 17.7192 6.25 16.4155C6.25 15.1119 7.2901 14.0718 8.59375 14.0718Z"
                                fill="white"
                            />
                        </svg>
                    </button>
                </div>
                <span className='listing-count'>{stringsoflanguages.noofmembers}: {(filteredConnections ?? []).length}</span>
                {/* Member Cards Grid */}
                <div className="member-cards-grid" ref={listScrollRef}>
                    {(filteredConnections ?? []).map((member) => {
                        const firstName = normalizeDisplayValue(member?.member_fname);
                        const lastName = normalizeDisplayValue(member?.member_lname);
                        const fullName = `${firstName} ${lastName}`.trim() || "N/A";
                        const memberSince = normalizeDisplayValue(member?.added_date);
                        const title = normalizeDisplayValue(member?.title) || "N/A";
                        const city = normalizeDisplayValue(member?.city_name);
                        const country = normalizeDisplayValue(member?.country_name);
                        const location = [city, country].filter(Boolean).join(" - ") || "N/A";
                        const imageUrl =
                            normalizeDisplayValue(member?.member_image_thumb) ||
                            normalizeDisplayValue(member?.member_image) ||
                            profileAvatar;

                        return (
                            <div className="member-card" key={member?.user_id || fullName} onClick={() => handleMemberCardClick(member)}>
                                {member?.check_conn == 1 ? (
                                    <small className="connection-status">{stringsoflanguages.connected}</small>
                                ) : null}
                                <div className="member-info">
                                    <p className="member-since flex align-items-center gap-2">
                                        {memberSince ? `${stringsoflanguages.memberSince} ${memberSince}` : `${stringsoflanguages.memberSince} N/A`}

                                    </p>
                                    <h3 className="member-name">{fullName}
                                        {member?.isPremium == true ? (
                                            <span className="premium-member-star"><svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                                                <path d="M7.2868 9.91064L10.7796 22.0513L0 9.91064H7.2868Z" fill="#7323ff" />
                                                <path d="M7.42024 8.38808H0L6.86669 2.01175C7.00926 1.87014 7.20204 1.79102 7.403 1.79102H11.2271L7.42024 8.38808Z" fill="#7323ff" />
                                                <path d="M9.1778 8.38811L12.9841 1.7915L16.7905 8.38811H9.1778Z" fill="#7323ff" />
                                                <path d="M17.098 9.91064L12.9842 24.2091L8.87036 9.91064H17.098Z" fill="#7323ff" />
                                                <path d="M18.5481 8.38813L14.7412 1.79102H19.0727C19.2843 1.79102 19.4857 1.87881 19.6298 2.03361L26 8.38813H18.5481Z" fill="#7323ff" />
                                                <path d="M25.9683 9.91064L15.1887 22.0513L18.6815 9.91064H25.9683Z" fill="#7323ff" />
                                            </svg></span>
                                        ) : null}
                                    </h3>
                                    <p className="member-role">{title}</p>
                                    <p className="member-location mb-2">{location}</p>

                                </div>
                                <div className="member-image">
                                    <img src={imageUrl} alt={fullName} />
                                </div>
                            </div>
                        );
                    })}
                </div>

                {!isMobile && (
                    <div className="btn-section btn-section-gear" ref={gearMenuRef}>
                        <button
                            type="button"
                            className={`btn-primary gear-btn ${gearSpinning ? 'gear-spin' : ''}`}
                            onClick={() => {
                                setGearMenuOpen((prev) => !prev);
                                setGearSpinning(true);
                                setTimeout(() => setGearSpinning(false), 500);
                            }}
                            aria-label="Options"
                            aria-expanded={gearMenuOpen}
                        >
                            <i className="fa-solid fa-gear"></i>
                        </button>
                        {gearMenuOpen && (
                            <ul className="gear-dropdown" aria-label="Options list">
                                <li>
                                    <button
                                        type="button"
                                        className="gear-dropdown-item"
                                        onClick={() => {
                                            setGearMenuOpen(false);
                                            navigate('/premium-home/member-filter-100', {
                                                state: { premiumSidebarActive: 'Premium Members' },
                                            });
                                        }}
                                    >
                                        <i className="fa-solid fa-sliders"></i>
                                        <span>{stringsoflanguages.filter}</span>
                                    </button>
                                </li>
                            </ul>
                        )}
                    </div>
                )}

                {isMobile && (
                    <nav className="mobile-bottom-nav liquidGlass-wrapper dock feed-recived-mobile-bottom-nav" aria-label="Premium Members actions">
                        <div className="liquidGlass-effect" aria-hidden="true" />
                        <div className="liquidGlass-shine" aria-hidden="true" />
                        <div className="mobile-nav-item" aria-label="Filter" onClick={() =>
                            navigate('/premium-home/member-filter-100', {
                                state: { premiumSidebarActive: 'Premium Members' },
                            })
                        }>
                            <i className="fa-solid fa-sliders"></i>
                        </div>
                    </nav>
                )}
            </div>
            <svg style={{ display: 'none' }} aria-hidden="true">
                <filter id="glass-distortion" x="0%" y="0%" width="100%" height="100%" filterUnits="objectBoundingBox">
                    <feTurbulence type="fractalNoise" baseFrequency="0.01 0.01" numOctaves="1" seed="5" result="turbulence" />
                    <feComponentTransfer in="turbulence" result="mapped">
                        <feFuncR type="gamma" amplitude="1" exponent="10" offset="0.5" />
                        <feFuncG type="gamma" amplitude="0" exponent="1" offset="0" />
                        <feFuncB type="gamma" amplitude="0" exponent="1" offset="0.5" />
                    </feComponentTransfer>
                    <feGaussianBlur in="turbulence" stdDeviation="3" result="softMap" />
                    <feSpecularLighting in="softMap" surfaceScale="5" specularConstant="1" specularExponent="100" lightingColor="white" result="specLight">
                        <fePointLight x="-200" y="-200" z="300" />
                    </feSpecularLighting>
                    <feComposite in="specLight" operator="arithmetic" k1="0" k2="1" k3="1" k4="0" result="litImage" />
                    <feDisplacementMap in="SourceGraphic" in2="softMap" scale="150" xChannelSelector="R" yChannelSelector="G" />
                </filter>
            </svg>
        </>
    );
}